import { goalTypeOption } from '@/composables/goal/allowed-sub-items';
import { intersection } from 'lodash-es';
import { isNullOrUndefined } from 'shared/lib/object/object';

export const restrictNonWritableProperties = (nonWritableProperties) => (goal) => {
  goal.properties = goal.properties.filter((pv) => isNullOrUndefined(pv.property) || !nonWritableProperties.map((p) => p.uid).includes(pv.property.uid));
  return goal;
};

export const restrictForeignEntityProperties = ({ hasForeignEntityReference, spaceProperty, nativeTeamsIds }) => (goal) => {
  if (hasForeignEntityReference.value) {
    return goal;
  }

  for (let i = 0; i < goal.properties.length; i++) {
    const property = goal.properties[i].property;
    if (property === undefined) {
      continue;
    }
    if (property.uid !== spaceProperty.uid) {
      continue;
    }

    goal.properties[i].spaces = goal.properties[i].spaces.filter((o) => nativeTeamsIds.includes(o.uid));
  }

  return goal;
};

export const enforceAlignmentRule = (goalTypeProperty, select) => (goal) => {
  const parents = select(goal.parents.map((p) => p.uid));
  const allowedOptions = parents.reduce((res, next) => {
    const type = goalTypeOption(next, goalTypeProperty);
    if (type === null) {
      res.push(...goalTypeProperty.options);
      return res;
    }

    const tmp = [];
    goalTypeProperty.options.forEach((op) => {
      if (op.canBeChildOf.length === 0) {
        return;
      }
      if (op.canBeChildOf.map((c) => c.uid).includes(type.uid)) {
        tmp.push(op.uid);
      }
    });
    res.push(tmp);
    return res;
  }, []);
  if (goal.parents.length === 0) {
    allowedOptions.push(goalTypeProperty.options.map((o) => o.uid));
  }
  const allowedGoalTypeOptionIds = intersection(...allowedOptions);

  const goalType = goalTypeOption(goal, goalTypeProperty);
  if (goalType === null) {
    if (allowedGoalTypeOptionIds.length === 0) {
      return goal;
    }

    for (let i = 0; i < goal.properties.length; i++) {
      if (goal.properties[i].property.uid !== goalTypeProperty.uid) {
        continue;
      }

      goal.properties[i].selectedOptions = [{ uid: allowedGoalTypeOptionIds[0] }];
    }
    return goal;
  }

  if (allowedGoalTypeOptionIds.length === 0 || allowedGoalTypeOptionIds.includes(goalType.uid)) {
    return goal;
  }

  for (let i = 0; i < goal.properties.length; i++) {
    if (goal.properties[i].property.uid !== goalTypeProperty.uid) {
      continue;
    }

    goal.properties[i].selectedOptions = [{ uid: allowedGoalTypeOptionIds[0] }];
  }
  return goal;
};
